import axios from "axios";
import { toast } from "react-toastify";
import { confApp } from "../CONF_APP";
// import { getToken } from "../utils/token";

const axiosInstance = axios.create({
  baseURL: confApp.API_URL,
});

axiosInstance.interceptors.response.use(null, (error) => {
  console.log(error);
  const expectedError =
    error.response && error.response >= 400 && error.response < 500;
  if(error.code === "ERR_NETWORK"){
    toast.error("Ocurrio un error de conexión", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  }
  if (!expectedError) {
    toast.error(error.response.data.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  }

  return Promise.reject(error);
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
};